export default __webpack_public_path__ + "static/media/nrCAN.1e00706e.png";